module.exports = __webpack_public_path__ + "img/huawei.a9a93e8d.svg";